import React, { Fragment } from 'react';

import { ModalControl } from '../../../context/modal/modal-context';
import ChartModal from '../../../shared/components/chart-modal';

const menSizeChart = [
	{displayName:'', values: ['S', 'M', 'L', 'XL','XXL']},
	{displayName:'Chest', values: [['36-39 in','95 cm'], ['39-41 in','102 cm'], ['41-43 in','107 cm'], ['43-46 in','113 cm'], ['46-49 in','122 cm']]},
	{displayName:'Waist', values: [['30-33 in','81 cm'], ['33-35 in','86 cm'], ['36-38 in','94 cm'], ['38-42 in','104 cm'], ['42-45 in','112 cm']]},
	{displayName:'Hip', values: [['36-39 in','95 cm'], ['39-41 in','102 cm'], ['41-43 in','107 cm'], ['43-46 in','114 cm'], ['46-49','122cm']]},
];

const womenSizeChart = [
	{displayName:'', values: ['XS', 'S', 'M', 'L','XL']},
	{displayName:'Size', values: ['4-6', '6-8', '8-10', '10-12', '12-14']},
	{displayName:'Chest', values: [['31-33 in','81 cm'], ['33-35 in','86 cm'], ['35-37 in','91 cm'], ['37-39 in','96 cm'], ['39-42 in','102 cm']]},
	{displayName:'Waist', values: [['24-26 in','63 cm'], ['36-28 in','68 cm'], ['28-30 in','74 cm'], ['30-32 in','79 cm'], ['32-35 in','85 cm']]},
	{displayName:'Hip', values: [['34-36 in','89 cm'], ['36-38 in','89 cm'], ['38-40 in','99 cm'], ['40-42 in','104 cm'], ['42-44 in','109 cm']]},
];

class SwatchDetails extends React.Component{
    render(){
        const { type, value } = this.props;
        return(
            <Fragment>
            {
                type === "size" &&
                <ModalControl
                    content={ChartModal}
                    contentProps={{columns: value[0]==='M' ? menSizeChart : womenSizeChart, header: `${value[0]==='M' ? 'Men' : 'Women'}'s size chart`}}
                    modalProps={{className: 'size-chart-modal'}}
                >
                    {(props) => (
                        <div className="chart-label" onClick={props.openModal}>Size chart</div>
                    )}
                </ModalControl>
            }
            </Fragment>
        )
    }
}

export default SwatchDetails;
